/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FunktionsbereichPruefplaene } from '../model/funktionsbereichPruefplaene';
// @ts-ignore
import { FunktionsbereichRolle } from '../model/funktionsbereichRolle';
// @ts-ignore
import { FunktionsbereichRollen } from '../model/funktionsbereichRollen';
// @ts-ignore
import { Pruefantwort } from '../model/pruefantwort';
// @ts-ignore
import { PruefantwortDetail } from '../model/pruefantwortDetail';
// @ts-ignore
import { Pruefaufgabe } from '../model/pruefaufgabe';
// @ts-ignore
import { PruefaufgabeDetail } from '../model/pruefaufgabeDetail';
// @ts-ignore
import { Pruefcheckliste } from '../model/pruefcheckliste';
// @ts-ignore
import { PruefchecklisteDetail } from '../model/pruefchecklisteDetail';
// @ts-ignore
import { Pruefobjekt } from '../model/pruefobjekt';
// @ts-ignore
import { PruefobjektDetail } from '../model/pruefobjektDetail';
// @ts-ignore
import { PruefplanDetail } from '../model/pruefplanDetail';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AdminQueryService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * GetFunktionsbereichePruefplaeneAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/funktionsbereiche/pruefplaene
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getFunktionsbereichePruefplaeneAdmin(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FunktionsbereichPruefplaene>>;
    public getFunktionsbereichePruefplaeneAdmin(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FunktionsbereichPruefplaene>>>;
    public getFunktionsbereichePruefplaeneAdmin(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FunktionsbereichPruefplaene>>>;
    public getFunktionsbereichePruefplaeneAdmin(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/funktionsbereiche/pruefplaene`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FunktionsbereichPruefplaene>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetFunktionsbereicheRollen
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/funktionsbereiche/rollen
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getFunktionsbereicheRollen(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FunktionsbereichRollen>>;
    public getFunktionsbereicheRollen(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FunktionsbereichRollen>>>;
    public getFunktionsbereicheRollen(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FunktionsbereichRollen>>>;
    public getFunktionsbereicheRollen(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/funktionsbereiche/rollen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FunktionsbereichRollen>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PruefplanDetail>;
    public getPruefplanAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PruefplanDetail>>;
    public getPruefplanAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PruefplanDetail>>;
    public getPruefplanAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PruefplanDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanAntwortAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/antworten/{antwort_id}
     * @param pruefplanId 
     * @param antwortId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanAntwortAdmin(pruefplanId: string, antwortId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PruefantwortDetail>;
    public getPruefplanAntwortAdmin(pruefplanId: string, antwortId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PruefantwortDetail>>;
    public getPruefplanAntwortAdmin(pruefplanId: string, antwortId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PruefantwortDetail>>;
    public getPruefplanAntwortAdmin(pruefplanId: string, antwortId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanAntwortAdmin.');
        }
        if (antwortId === null || antwortId === undefined) {
            throw new Error('Required parameter antwortId was null or undefined when calling getPruefplanAntwortAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/antworten/${this.configuration.encodeParam({name: "antwortId", value: antwortId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PruefantwortDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanAntwortenAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/antworten
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanAntwortenAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Pruefantwort>>;
    public getPruefplanAntwortenAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Pruefantwort>>>;
    public getPruefplanAntwortenAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Pruefantwort>>>;
    public getPruefplanAntwortenAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanAntwortenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/antworten`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Pruefantwort>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefaufgabeAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/checklisten/{checkliste_id}/aufgaben/{aufgabe_id}
     * @param pruefplanId 
     * @param checklisteId 
     * @param aufgabeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefaufgabeAdmin(pruefplanId: string, checklisteId: string, aufgabeId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PruefaufgabeDetail>;
    public getPruefplanPruefaufgabeAdmin(pruefplanId: string, checklisteId: string, aufgabeId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PruefaufgabeDetail>>;
    public getPruefplanPruefaufgabeAdmin(pruefplanId: string, checklisteId: string, aufgabeId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PruefaufgabeDetail>>;
    public getPruefplanPruefaufgabeAdmin(pruefplanId: string, checklisteId: string, aufgabeId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefaufgabeAdmin.');
        }
        if (checklisteId === null || checklisteId === undefined) {
            throw new Error('Required parameter checklisteId was null or undefined when calling getPruefplanPruefaufgabeAdmin.');
        }
        if (aufgabeId === null || aufgabeId === undefined) {
            throw new Error('Required parameter aufgabeId was null or undefined when calling getPruefplanPruefaufgabeAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checklisten/${this.configuration.encodeParam({name: "checklisteId", value: checklisteId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aufgaben/${this.configuration.encodeParam({name: "aufgabeId", value: aufgabeId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PruefaufgabeDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefaufgabenAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/checklisten/{checkliste_id}/aufgaben
     * @param pruefplanId 
     * @param checklisteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefaufgabenAdmin(pruefplanId: string, checklisteId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Pruefaufgabe>>;
    public getPruefplanPruefaufgabenAdmin(pruefplanId: string, checklisteId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Pruefaufgabe>>>;
    public getPruefplanPruefaufgabenAdmin(pruefplanId: string, checklisteId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Pruefaufgabe>>>;
    public getPruefplanPruefaufgabenAdmin(pruefplanId: string, checklisteId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefaufgabenAdmin.');
        }
        if (checklisteId === null || checklisteId === undefined) {
            throw new Error('Required parameter checklisteId was null or undefined when calling getPruefplanPruefaufgabenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checklisten/${this.configuration.encodeParam({name: "checklisteId", value: checklisteId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aufgaben`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Pruefaufgabe>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefchecklisteAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/checklisten/{checkliste_id}
     * @param pruefplanId 
     * @param checklisteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefchecklisteAdmin(pruefplanId: string, checklisteId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PruefchecklisteDetail>;
    public getPruefplanPruefchecklisteAdmin(pruefplanId: string, checklisteId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PruefchecklisteDetail>>;
    public getPruefplanPruefchecklisteAdmin(pruefplanId: string, checklisteId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PruefchecklisteDetail>>;
    public getPruefplanPruefchecklisteAdmin(pruefplanId: string, checklisteId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefchecklisteAdmin.');
        }
        if (checklisteId === null || checklisteId === undefined) {
            throw new Error('Required parameter checklisteId was null or undefined when calling getPruefplanPruefchecklisteAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checklisten/${this.configuration.encodeParam({name: "checklisteId", value: checklisteId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PruefchecklisteDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefchecklistenAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/checklisten
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefchecklistenAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Pruefcheckliste>>;
    public getPruefplanPruefchecklistenAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Pruefcheckliste>>>;
    public getPruefplanPruefchecklistenAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Pruefcheckliste>>>;
    public getPruefplanPruefchecklistenAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefchecklistenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checklisten`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Pruefcheckliste>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefobjektAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/pruefobjekte/{pruefobjekt_id}
     * @param pruefplanId 
     * @param pruefobjektId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefobjektAdmin(pruefplanId: string, pruefobjektId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PruefobjektDetail>;
    public getPruefplanPruefobjektAdmin(pruefplanId: string, pruefobjektId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PruefobjektDetail>>;
    public getPruefplanPruefobjektAdmin(pruefplanId: string, pruefobjektId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PruefobjektDetail>>;
    public getPruefplanPruefobjektAdmin(pruefplanId: string, pruefobjektId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefobjektAdmin.');
        }
        if (pruefobjektId === null || pruefobjektId === undefined) {
            throw new Error('Required parameter pruefobjektId was null or undefined when calling getPruefplanPruefobjektAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pruefobjekte/${this.configuration.encodeParam({name: "pruefobjektId", value: pruefobjektId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PruefobjektDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanPruefobjekteAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/pruefobjekte
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanPruefobjekteAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Pruefobjekt>>;
    public getPruefplanPruefobjekteAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Pruefobjekt>>>;
    public getPruefplanPruefobjekteAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Pruefobjekt>>>;
    public getPruefplanPruefobjekteAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanPruefobjekteAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pruefobjekte`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Pruefobjekt>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanRollenControllerAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/rollen/controller
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanRollenControllerAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FunktionsbereichRolle>>;
    public getPruefplanRollenControllerAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FunktionsbereichRolle>>>;
    public getPruefplanRollenControllerAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FunktionsbereichRolle>>>;
    public getPruefplanRollenControllerAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanRollenControllerAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rollen/controller`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FunktionsbereichRolle>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPruefplanRollenPrueferAdmin
     * ORGA App Zugriff: * QsChecks - Zugriff  | Admin  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/admin/v1/pruefplaene/{pruefplan_id}/rollen/pruefer
     * @param pruefplanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPruefplanRollenPrueferAdmin(pruefplanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FunktionsbereichRolle>>;
    public getPruefplanRollenPrueferAdmin(pruefplanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FunktionsbereichRolle>>>;
    public getPruefplanRollenPrueferAdmin(pruefplanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FunktionsbereichRolle>>>;
    public getPruefplanRollenPrueferAdmin(pruefplanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pruefplanId === null || pruefplanId === undefined) {
            throw new Error('Required parameter pruefplanId was null or undefined when calling getPruefplanRollenPrueferAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/admin/v1/pruefplaene/${this.configuration.encodeParam({name: "pruefplanId", value: pruefplanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rollen/pruefer`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FunktionsbereichRolle>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
